import { Extension } from "@tiptap/core";
import { PluginKey } from "@tiptap/pm/state";
import { Suggestion } from "@tiptap/suggestion";
import { EmojiMatch, searchEmojis } from "util/searchEmojis";
import {
  createSuggestionPopupRenderer,
  SuggestionPopup,
} from "./createSuggestionPopupRenderer";

export type EmojiPopup = SuggestionPopup<EmojiMatch>;

type EmojiSuggestionArgs = {
  onPopupChange: (popup: EmojiPopup | null) => void;
};

type EmojiSuggestion = {
  extension: Extension;
  isOpen: () => boolean;
};

const EMOJI_CHAR = ":";
// One character after ":" is too noisy ("10:3", ":)"), Slack waits for two
const EMOJI_MIN_QUERY_LENGTH = 2;
const EMOJI_SUGGESTION_KEY = new PluginKey("chatEmojiSuggestion");

export const createEmojiSuggestion = ({
  onPopupChange,
}: EmojiSuggestionArgs): EmojiSuggestion => {
  const renderer = createSuggestionPopupRenderer<EmojiMatch, EmojiMatch>({
    onSelect: (item, command) => command(item),
    onPopupChange,
  });

  const extension = Extension.create({
    name: "emojiSuggestion",

    addProseMirrorPlugins() {
      return [
        Suggestion<EmojiMatch, EmojiMatch>({
          editor: this.editor,
          char: EMOJI_CHAR,
          pluginKey: EMOJI_SUGGESTION_KEY,
          minQueryLength: EMOJI_MIN_QUERY_LENGTH,
          items: ({ query }) => searchEmojis(query),
          command: ({ editor, range, props }) => {
            editor
              .chain()
              .focus()
              .insertContentAt(range, `${props.native} `)
              .run();
          },
          render: renderer.render,
        }),
      ];
    },
  });

  return { extension, isOpen: renderer.isOpen };
};
